/**
 * Internal and External Imports
 *
 * Add your third party vendor imports near the top of the file,
 * and adweek assets underneath.
 */

// import adw from 'adw';
import Modal from 'bootstrap/js/src/modal.js';
import 'awesomplete';
import './vendor/js.cookie.min.js';
import './custom/imports';
import './galleries/gallery-mockup';
import './galleries/scroller';
import './utils/initTooltips';
import './utils/initBootstrapTooltips';
import './helpers';
import './custom/modals';
import './custom/lytics';
import './custom/rdt';

import './deferred-loading/sidebar-containers';

import './custom/onetrust';
import './custom/credspark';
import './custom/inline-scripts';
import './custom/company-autocomplete';
import './custom/membership-check';
import './custom/keywee-track';
//import './custom/file-script-load'
import './custom/login-key-event';
import './custom/issue-subscribe-link-hide';

import './custom/sustainibility.js';
import './custom/user-loggedIn-event';
import './contextual-greeting';

import getTaxPostMarkupByTermId from './posts/getTaxPostMarkupByTermId';
import getCustomPostTypePosts from './posts/getCustomPostTypePosts';
import getLatestNewsPostTypePosts from './posts/getLatestNewsPostTypePosts';
import initTabListeners from './utils/initTabListeners';
import replaceUrls from './utils/replaceUrls'

import './parsely';
import { getVerticalTermIndexItemMarkup } from './endpoints/query/getVertical';
import replaceWithMarkup from "./utils/replaceWithMarkup";
import { getAllTerms } from "./endpoints/query/getTerms";
import { getPostsMarkupByIDs } from "./endpoints/query/getPosts";

import is_probably_googlebot from './utils/isProbablyGooglebot';

import './sidebar';

// Init BS modals
function initBSModals() {
    const bsModal = document.querySelectorAll('.modal');
    if (bsModal.length) {
        bsModal.forEach((modal) => {
            const bs = new Modal(modal, {
                backdrop: 'static',
                keyboard: false
            });
        });
    }
}

window.addEventListener('DOMContentLoaded', function () {
    initBSModals();
});

window.adw.is_probably_googlebot = is_probably_googlebot();

// Dev helper for force reloading the cache
window.refresh = _ => location.reload( true );

// Setup global helpers
window.adw.posts = {
    getVerticalTermIndexItemMarkup,
	getTaxPostMarkupByTermId,
    getCustomPostTypePosts,
    getLatestNewsPostTypePosts,
    getPostsMarkupByIDs
};

window.adw.terms = {
    getAllTerms
};

window.adw.utils = {
	initTabListeners,
	replaceUrls,
    replaceWithMarkup
};

console.log("%cLoading top.js", "color: yellow; font-style: italic; background-color: blue;padding: 2px");
